module.exports = __webpack_public_path__ + "img/boundary-hide.7d7cb817.svg";